"use client";

import { LineChart } from "lucide-react";
import { cn } from "@/lib/utils";

interface CustomIndicatorIconProps {
  name: string;
  iconDataUrl?: string;
  className?: string;
  size?: number;
}

export default function CustomIndicatorIcon({
  name,
  iconDataUrl,
  className,
  size = 32,
}: CustomIndicatorIconProps) {
  if (iconDataUrl) {
    return (
      <img
        src={iconDataUrl}
        alt={`${name} icon`}
        width={size}
        height={size}
        className={cn(
          "shrink-0 rounded-md border border-border object-cover bg-muted/30",
          className
        )}
      />
    );
  }

  return (
    <div
      className={cn(
        "shrink-0 rounded-md border border-border bg-primary/10 text-primary flex items-center justify-center",
        className
      )}
      style={{ width: size, height: size }}
      aria-hidden
    >
      <LineChart className="h-4 w-4" />
    </div>
  );
}
